import * as React from 'react';
import styled from 'styled-components';
import MDSpinner from 'react-md-spinner';

export const Loader: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Loading>
      <MDSpinner size={30} singleColor="#e8c893" />
      {text ? <span className="loader-label">{text}</span> : null}
    </Loading>
  );
};

const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  color: white;

  .loader-label {
    margin-left: 20px;
  }
`;
